import React from 'react'

import ListQIdeas from '../../../react4xp/components/ListQIdeas'

function ListIdeasPart({title, cta, qIdeasLiked, endpoint, startValues, strings, colors, services, isLogged}) {
  return (
    <ListQIdeas
		title={title}
		endpoint={endpoint}
		overviewCTA={cta}
		qIdeasLiked={qIdeasLiked}
		startValues={startValues}
		strings={strings}
		bgColor={colors.bgColor}
		isWhite={colors.isWhite}
		services={services}
		isLogged={isLogged}
		type='ideas'
    />
  )
}

export default (props) => <ListIdeasPart {...props} />
